<header *ngIf="!isMobileRender" class="content-max-width header" [class.active]="isMenuActive">
  <a href="/au" class="header__logo_container">
    <img class="header__logo" src="/au/giftcards/assets/zip-logo.svg" width="72"  alt="zip logo"/>
  </a>

  <nav class="header__nav header__nav-main" [class.active]="isMenuActive">
    <div class="nav-main__header">
      <zip-co-country-switcher></zip-co-country-switcher>
      <button class="header__nav-cta-button" (click)="toggleMenu()">
        <img src="/au/giftcards/assets/close.svg" width="15" />
      </button>
    </div>

    <nav class="nav-main__tab">
      <ul class="nav-main__tab-list">
        <li class="nav-main__tab-list-item">
          <button
            class="nav-main__tab-cta"
            [class.active]="tab === 'customer'"
            (click)="switchTab('customer')"
          >
            <span> For Customers</span>
          </button>
        </li>
        <li class="nav-main__tab-list-item">
          <button
            class="nav-main__tab-cta"
            [class.active]="tab === 'business'"
            (click)="switchTab('business')"
          >
            For Businesses
          </button>
        </li>
      </ul>
    </nav>

    <header-menu
      class="header-menu header-menu--customer"
      [menuItems]="customerMenu"
      [class.active]="isMenuActive && tab === 'customer'"
    ></header-menu>

    <header-menu
      class="header-menu header-menu--business"
      [menuItems]="isMenuActive ? businessMenu : [{ label: 'For Businesses', items: businessMenu }]"
      [class.active]="isMenuActive && tab === 'business'"
    ></header-menu>

    <nav *ngIf="tab === 'customer'" class="nav-main__footer">
      <ul class="nav-main__footer-list">
        <li class="nav-main__footer-list-item">
          <button
            class="header__nav-cta header__nav-cta--light nav-main__footer-cta"
            (click)="signIn()"
          >
            Log In
          </button>
        </li>
        <li class="nav-main__footer-list-item">
          <a
            class="header__nav-cta header__nav-cta--dark nav-main__footer-link"
            href="/au/create-an-account"
            >Apply now</a
          >
        </li>
      </ul>
    </nav>
  </nav>

  <nav class="header__nav header__nav-acqui">
    <ul class="header__nav-list">
      <li>
        <button class="header__nav-cta header__nav-cta--light" (click)="signIn()">Log In</button>
      </li>
      <li>
        <a class="header__nav-cta header__nav-cta--dark" href="/au/create-an-account">Apply now</a>
      </li>
      <li>
        <button class="header__nav-cta-button" (click)="toggleMenu()">
          <img src="/au/giftcards/assets/hamburger.svg" width="20" />
        </button>
      </li>
    </ul>

    <div class="header__nav-overlay" [class.active]="isMenuActive" (click)="toggleMenu()"></div>
  </nav>
</header>
